import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { themes } from "@/mocks/homeContent";

export default function Themes() {
  const [activeId, setActiveId] = useState(themes.tabs[0].id);

  return (
    <section id="themes" className="bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading light kicker="Themes" title={themes.title} desc={themes.desc} />

        <div className="mt-10 flex flex-wrap gap-2 rounded-full border border-background-50/15 bg-background-50/5 p-1.5 w-fit">
          {themes.tabs.map((tab) => {
            const isActive = tab.id === activeId;
            return (
              <button
                key={tab.id}
                type="button"
                aria-pressed={isActive}
                onClick={() => setActiveId(tab.id)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-background-200/80 hover:bg-background-50/10 hover:text-background-50"
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 rounded-lg border border-background-50/15 bg-background-50/5 p-6 md:p-10">
          {themes.tabs.map((tab) => (
            <div
              key={tab.id}
              className={
                tab.id === activeId ? "grid gap-8 lg:grid-cols-2 lg:gap-12" : "hidden"
              }
            >
              <div>
                <h3 className="font-heading text-xl font-semibold text-background-50 md:text-2xl">
                  {tab.headline}
                </h3>
                <blockquote className="mt-6 border-l-2 border-accent-500 pl-4 text-sm italic leading-relaxed text-accent-200 md:text-base">
                  {tab.quote}
                </blockquote>
              </div>

              <ul className="space-y-4">
                {tab.points.map((point) => (
                  <li key={point} className="flex gap-3">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-lg text-accent-400"></i>
                    <span className="text-sm leading-relaxed text-background-200/90 md:text-[15px]">
                      {point}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}